import script from "./PoliticaDePrivacidade.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaDePrivacidade.vue?vue&type=style&index=0&id=21d8aea6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d8aea6"]])

export default __exports__